/* ============================================================================
   SERVICE PROFILE — declarative registration list (priority = boot order).
   Swapping a mock implementation for a real one later is a one-line change here
   (point useClass at the real service; the token + contract are unchanged).
   ============================================================================ */
import { createServiceProfile } from '../runtime';
import type { ServiceProfile, ServiceRegistration } from '../runtime';
import type { AppConfig } from '../config';
import { CONFIG_TOKEN, AUTH_TOKEN, MOCK_STORE_TOKEN, PRESENCE_TOKEN, SCOPE_TOKEN } from '../services/tokens';
import { ConfigService, AuthSessionService, MockStoreService, PresenceService, ScopeService } from '../services';

export function buildProfile(config: AppConfig): ServiceProfile {
  // Cast via unknown: registrations mix services with different TConfig generics,
  // which the framework resolves at runtime; the token + contract keep call sites safe.
  const services = [
    { token: CONFIG_TOKEN, useClass: ConfigService, name: 'ConfigService', priority: 1, config },
    { token: AUTH_TOKEN, useClass: AuthSessionService, name: 'AuthSessionService', priority: 5 },
    { token: MOCK_STORE_TOKEN, useClass: MockStoreService, name: 'MockStoreService', priority: 10 },
    { token: PRESENCE_TOKEN, useClass: PresenceService, name: 'PresenceService', priority: 12 },
    {
      token: SCOPE_TOKEN,
      useClass: ScopeService,
      name: 'ScopeService',
      priority: 15,
      dependencies: [MOCK_STORE_TOKEN],
    },
  ] as unknown as ServiceRegistration[];

  return createServiceProfile('yperea-console', services);
}
